import * as React from 'react';
import { IconAd, IconData, IconInfrastructure, IconPriceChart } from './icons';

export interface IData {
  title: string;
  afterTitle?: string;
  subTitle: string;
  list: string[];
  icon: React.ReactElement;
}

export const DATA: IData[] = [
  {
    title: 'Объявления с Циан',
    subTitle: 'Вся Россия',
    list: ['Опубликованные объявления', 'Снятые с экспозиции объявления'],
    icon: <IconAd />,
  },
  {
    title: 'Данные по продажам',
    afterTitle: '*',
    subTitle: 'Москва и область, СПБ и область',
    list: ['ДДУ', 'Эскроу'],
    icon: <IconData />,
  },
  {
    title: 'Инфраструктура и застройка',
    subTitle: 'Вся Россия',
    list: ['Транспортная доступность', 'Близость к школам, магазинам'],
    icon: <IconInfrastructure />,
  },
  {
    title: 'Динамика цен',
    subTitle: 'Вся Россия',
    list: ['Первичка и вторичка', 'Коммерческая недвижимость'],
    icon: <IconPriceChart />,
  },
];
